import React, { ReactElement, useState } from "react";
import AppHeaderAdmin from "../../components/Header/AdminHeader";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import MetaTags from "../../components/MetaTags/MetaTags";
import { routes } from "../../routes/routes";
import { useHistory } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { useLanguage } from "../../locale/useLanguage";
import "./admin.styles.scss";
import Sidebar from "components/Sidebar/Sidebar";
import Footer from "components/Footer/Footer";

const AdminLayout: React.FC<{
  title: string;
  hideOnBack?: boolean;
  children?: ReactElement;
}> = ({ children, title = "", hideOnBack = false }) => {
  const history = useHistory();
  const [t] = useLanguage();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <MetaTags title={title} />
      <div className="admin-layout admin-layout--with-sidebar">
        <CssBaseline />
        <AppHeaderAdmin
          menu={routes}
          hasSidebar
          openDrawerAction={() => {
            setIsDrawerOpen(!isDrawerOpen);
          }}
        />
        <Sidebar
          mobileOpen={isDrawerOpen}
          onMobileClose={() => setIsDrawerOpen(false)}
        />
        <Box component="main" className="admin-layout-box-container">
          <Grid container className="system-page" alignContent="start">
            {!hideOnBack && (
              <Grid item container xs={12} sx={{ height: "64px" }}>
                <Button
                  className="mt-2"
                  style={{ fontSize: "1.3rem" }}
                  startIcon={<ArrowBack />}
                  onClick={() => history.goBack()}
                >
                  {t("common.go_back")}
                </Button>
              </Grid>
            )}
            {children}
          </Grid>
          <Footer />
        </Box>
      </div>
    </>
  );
};
export default AdminLayout;
